/**
 * intro redux
 * */

import { createSlice } from "@reduxjs/toolkit";
import {PURGE} from "redux-persist";


const initialState = {
  designHistoryList: null
}

const designHistorySlice = createSlice({
  name : "designHistory",
  initialState : initialState,
  reducers : {
    setDesignHistoryList(state,action){
      state.designHistoryList = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
})

export default designHistorySlice
